import React from 'react';
import { Link } from 'react-router-dom';
import CrushShyPageHead from '../../components/CrushShyPageHead';
import { crushshySeo } from '../../seo/crushshySeo';
import { useLanguage } from '../../context/LanguageContext';
import { useCrushShyT } from '../../hooks/useCrushShyT';

const CrushShyLegal = ({ seo, title, children }) => {
  const t = useCrushShyT();
  const { toggleLanguage } = useLanguage();

  return (
    <>
      <CrushShyPageHead title={seo.title} description={seo.description} path={seo.path} />
      <div className="min-h-screen bg-[#090B16] text-white px-6 py-16 max-w-2xl mx-auto">
        <nav className="mb-8 text-sm flex flex-wrap gap-4 items-center" aria-label="CrushShy navigation">
          <Link to="/crushshy" className="text-pink-400">
            {t('legalNavCrushShy')}
          </Link>
          <Link to="/" className="text-gray-500 hover:text-gray-300">
            {t('legalNavLoranrix')}
          </Link>
          <button
            type="button"
            onClick={toggleLanguage}
            className="ml-auto text-xs font-semibold px-2.5 py-1 rounded-md border border-pink-500/30 text-pink-300 hover:bg-pink-500/10"
          >
            {t('langToggle')}
          </button>
        </nav>
        <h1 className="text-3xl font-bold mb-6">{title}</h1>
        <article className="prose prose-invert text-gray-300 space-y-4 text-sm leading-relaxed">{children}</article>
      </div>
    </>
  );
};

export const CrushShyPrivacy = () => {
  const t = useCrushShyT();
  return (
    <CrushShyLegal seo={crushshySeo.privacy} title={t('privacyTitle')}>
      <p>{t('privacyP1')}</p>
      <p>{t('privacyP2')}</p>
      <p>{t('privacyP4')}</p>
      <p>
        {t('privacyP3')}{' '}
        <a href="https://loranrix.com" className="text-pink-400">
          loranrix.com
        </a>
        .
      </p>
    </CrushShyLegal>
  );
};

export const CrushShyTerms = () => {
  const t = useCrushShyT();
  return (
    <CrushShyLegal seo={crushshySeo.terms} title={t('termsTitle')}>
      <p>{t('termsP1Alt')}</p>
      <p>{t('termsP2Alt')}</p>
      <p>{t('termsP3Alt')}</p>
    </CrushShyLegal>
  );
};
